import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/styles.css";
import "./styles/App.css";
import "./styles/SignUpForm.css";
import "./styles/ContactManagementPage.css";
import "./styles/HomePage.css";
import "./styles/MaintenanceRequestDetailsPage.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextProvider } from "./context/ContextProvider";
import { I18nextProvider } from "react-i18next";
import i18n, { initPromise } from "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Wait for i18next to initialize before rendering the app
initPromise
  .then(() => {
    root.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18n}>
          <ContextProvider>
            <App />
          </ContextProvider>
        </I18nextProvider>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error("Failed to initialize i18next:", error);
    // Render app anyway - i18next will use fallback language
    root.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18n}>
          <ContextProvider>
            <App />
          </ContextProvider>
        </I18nextProvider>
      </React.StrictMode>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
